'use strict';

var React = require('react');
var reactTable = require('@tanstack/react-table');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const useTable = (props) => {
    const { data, state, pageCount, manualPagination, columns, enableGlobalFilter = false, ...restOptions } = props;
    const [expanded, setExpanded] = React__namespace.useState({});
    const [sorting, setSorting] = React__namespace.useState([]);
    const [columnFilters, setColumnFilters] = React__namespace.useState([]);
    const table = reactTable.useReactTable({
        data,
        columns,
        pageCount,
        state: {
            expanded,
            sorting,
            columnFilters,
            ...state,
        },
        autoResetPageIndex: false,
        getSortedRowModel: reactTable.getSortedRowModel(),
        getExpandedRowModel: reactTable.getExpandedRowModel(),
        getFilteredRowModel: reactTable.getFilteredRowModel(),
        getFacetedRowModel: reactTable.getFacetedRowModel(),
        getFacetedUniqueValues: reactTable.getFacetedUniqueValues(),
        getPaginationRowModel: !manualPagination ? reactTable.getPaginationRowModel() : undefined,
        onSortingChange: setSorting,
        onExpandedChange: setExpanded,
        onColumnFiltersChange: setColumnFilters,
        manualPagination,
        enableGlobalFilter,
        ...restOptions,
    });
    return table;
};

exports.useTable = useTable;
//# sourceMappingURL=useTable.js.map
